import Sidebar from "../components/Sidebar";
import { Header } from "../components/header";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { PreInsuranceDashboard } from "../components/pre-insurance-dashboard.component";


export function PreInsurancePage() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId="pre-insurance"
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                <div className="dashboard-main-content">
                    <Header
                        setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className='py-0 px-sm-3'>
                        <PreInsuranceDashboard />
                    </div>
                </div>
            </div>
        </div>
    );
}
